import { render, staticRenderFns } from "./ReferralView.vue?vue&type=template&id=68ed0fd0&"
import script from "./ReferralView.vue?vue&type=script&lang=ts&"
export * from "./ReferralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports